export default __webpack_public_path__ + "static/media/Prod the Weakness.7df5db49.png";